import { render } from "./InputRecipie.vue?vue&type=template&id=5a536277"
import script from "./InputRecipie.vue?vue&type=script&lang=js"
export * from "./InputRecipie.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__